// extracted by mini-css-extract-plugin
export default {"wrapper":"FooterPrivacy_wrapper__vPF+O","list":"FooterPrivacy_list__4jVEW","item":"FooterPrivacy_item__lowzF","year":"FooterPrivacy_year__lCWB4"};